import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ItemM } from '../utils/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ItemS {
  http = inject(HttpClient);
  url = `${environment.apiUrl}/Item`;

  // Create new item
  add(item: ItemM | FormData): Observable<ItemM> {
    return this.http.post<ItemM>(this.url, item);
  }

  // Get all items (cached)
  search(params: any): Observable<ItemM[]> {
    return this.http.post<ItemM[]>(`${this.url}/Search`, params);
  }

  // Get single item by ID (cached)
  get(id: number): Observable<ItemM> {
    return this.http.get<ItemM>(`${this.url}/${id}`);
  }

  // Update item
  update(id: number, itemData: ItemM | FormData): Observable<ItemM> {
    return this.http.put<ItemM>(`${this.url}/${id}`, itemData);
  }

  // Delete item
  delete(id: number): Observable<ItemM> {
    return this.http.delete<ItemM>(`${this.url}/${id}`);
  }
  
}
